import "./index.css";
import "./i18n";
import * as Sentry from "@sentry/react";
import React from "react";
import * as ReactDOM from "react-dom/client";
import { ApolloClient, ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "@acdc2/ui/components/theme-provider";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router";
import { App } from "./App.tsx";
import { onSigninCallback, userManager } from "./authentication.ts";
import { link } from "./client/links.ts";
import { cache } from "./client/caches.ts";

if (import.meta.env.VITE_ACDC2_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_ACDC2_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const client = new ApolloClient({
  link,
  cache,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider
        userManager={userManager}
        onSigninCallback={onSigninCallback}
      >
        <ApolloProvider client={client}>
          <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
            <App />
          </ThemeProvider>
        </ApolloProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
